import { createFileRoute } from '@tanstack/react-router'
import { SystemViewPage } from 'pages/systemView/SystemView'
import { z } from 'zod'

const parseParams = z.object({
  entryID: z.string(),
})

const searchSchema = z.object({
  whiteboard: z.string().optional(),
})

function RouteComponent() {
  const { entryID } = Route.useParams()
  const { whiteboard } = Route.useSearch()
  return <SystemViewPage entryID={entryID} whiteboardId={whiteboard} />
}

export const Route = createFileRoute('/systemview/$entryID')({
  component: RouteComponent,
  params: {
    parse: (params) => parseParams.parse(params),
  },
  validateSearch: (search) => searchSchema.parse(search),
  staticData: {
    title: 'System View',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
